/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `PENDING` - Pending
 * * `PARTIALLY_SIGNED` - Partially signed
 * * `COMPLETED` - Completed
 * * `VOIDED` - Voided
 */
export enum SignatureRequestStatusEnum {
    PENDING = 'PENDING',
    PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
    COMPLETED = 'COMPLETED',
    VOIDED = 'VOIDED',
}
